import React, { Fragment } from 'react';

import { IParams, useMaxAndMin } from './useMaxAndMin'

const formatValue = (value: string) => {
  if (!value) return value;
  const res = value?.substring(0, 8);
  if (res.endsWith('.')) {
    return res?.substring(0, 7);
  }
  return res
}

export const Num: React.FC<IParams> = ({ rules, coinCode, precision, label, cacheRef }) => {
  const value = `${useMaxAndMin({ coinCode, precision, rules, label, cacheRef })}`;
  return (
    <Fragment>{formatValue(value)}</Fragment>
  )
}
